import React, { useState, useLayoutEffect, useRef } from 'react';
import clsx from 'clsx';

import * as styles from '@styles/modules/common.module.scss';

const FadeInSection = ({ children, showFade }) => {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();
  useLayoutEffect (() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(entry.isIntersecting);
          observer.unobserve(domRef.current);
        }
      });
    });
    observer.observe(domRef.current);
    return () => observer.unobserve(domRef.current);
  }, []);
  return (
    <div className={clsx({[styles.fadeInSection]:showFade, [styles.isVisible]:isVisible})} ref={domRef}>
      {children}
    </div>
  );
}

export default FadeInSection
